if (document.documentElement.lang.toLowerCase().split('-')[0] === 'de') {
(() => {
  'use strict';
  const tx=value=>(document.documentElement.lang.toLowerCase().split('-')[0]==='de'?globalThis.AsteriaGermanCopy:globalThis.AsteriaItalianCopy)?.text(value)??String(value??'');
  const root = () => { const r = globalThis.Shopify?.routes?.root || '/'; return r.endsWith('/') ? r : r + '/'; };
  const esc = v => String(tx(v)).replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;').replaceAll("'","&#039;");
  const fold = v => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ı/g,'i').toLowerCase();
  const money = (cents, locale, currency) => {
    try { return new Intl.NumberFormat(locale === 'tr' ? 'tr-TR' : locale === 'it' ? 'it-IT' : locale === 'de' ? 'de-DE' : 'en-US', {style:'currency',currency:currency || 'TRY'}).format(Number(cents) / 100); }
    catch (_) { return (Number(cents) / 100).toFixed(2) + ' ' + (currency || ''); }
  };
  async function load(row) {
    try {
      const response = await fetch(root() + 'products/' + encodeURIComponent(row.handle) + '.js', {credentials:'same-origin',headers:{Accept:'application/json'}});
      if (!response.ok) return null;
      const product = await response.json();
      if (String(product.id) !== String(row.productId) || !product.featured_image) return null;
      const variant = (product.variants || []).find(v => String(v.id) === String(row.variantId) && String(v.sku) === String(row.sku) && v.available === true && Number(v.price) > 0);
      return variant ? {row, product, variant} : null;
    } catch (_) { return null; }
  }
  function candidates(stones) {
    const groups = globalThis.AsteriaBirthChartData?.productsByIntent || {};
    const selected = stones.map(fold);
    const seen = new Set();
    const rows = [];
    for (const group of Object.values(groups)) for (const row of group) {
      if (seen.has(row.productId)) continue;
      seen.add(row.productId);
      const matched = selected.reduce((score, stone) => score + (fold(row.matches).includes(stone) ? 1 : 0), 0);
      if (matched) rows.push({row, matched});
    }
    return rows.sort((a,b) => b.matched - a.matched || b.row.score - a.row.score).map(x => x.row).slice(0,12);
  }
function matchedFamilies(product,stones,locale){
 const title=String(product.title||'').toLocaleLowerCase('tr-TR');
 const tags=new Set((Array.isArray(product.tags)?product.tags:[]).map(t=>String(t).toLocaleLowerCase('tr-TR')));
 const families=new Map();
 const aliases={'jade-yesim-ceyt-tasi':['jade','yeşim','ceyt'],'lapis-lazuli-tasi':['lapis'],'necef-tasi':['necef','kristal'],'kuvars-tasi':['kuvars','kristal']};
 for(const stone of stones||[]){
  const r=globalThis.AsteriaZodiacData?.routes?.[stone],media=r?globalThis.AsteriaStoneMedia?.[r.profile]:null;
  if(!media)continue;
  const names=aliases[r.profile]||[media.titleTr];
  const tag='tas_'+r.profile.replace(/-tasi$/,'').replace('jade-yesim-ceyt','yesim');
  if(tags.has(tag)||names.some(n=>title.includes(n.toLocaleLowerCase('tr-TR'))))families.set(r.profile,locale==='tr'?media.titleTr:media.titleEn);
 }
 return [...families.values()];
}

  async function render(host, stones, locale, currency) {
    if (!host) return;
    const run = String(Date.now()) + Math.random();
    host.dataset.run = run;
    host.innerHTML = '<p>' + (locale === 'tr' ? 'Gerçek tasarımlar kontrol ediliyor…' : tx('Checking real designs…')) + '</p>';
    const rows = candidates(stones);
    const found = (await Promise.all(rows.map(load))).filter(Boolean).map(item=>({...item,families:matchedFamilies(item.product,stones,locale)})).filter(item=>item.families.length).slice(0,4);
    if (host.dataset.run !== run) return;
    host.innerHTML = found.map(({row,product,variant,families}) => {
      const href = root() + 'products/' + row.handle + '?variant=' + row.variantId;
      return '<article class="ae-gate-product"><a href="' + esc(href) + '"><img src="' + esc(product.featured_image.replace(/^(?:http:)?\/\//,'https://')) + '" alt="' + esc(product.title) + '" loading="lazy" decoding="async"><span><strong>' + esc(product.title) + '</strong><small class="ae-chakra__product-reason">' + esc(locale==='tr'?'Profilindeki '+families.join(', ')+' taşları bu tasarımda sana eşlik ediyor.':tx('The ')+families.join(', ')+tx(' stones in your profile are featured in this design.')) + '</small><small>' + esc(money(variant.price,locale,currency)) + '</small><em>' + esc(locale === 'tr' ? 'Ürünü gör →' : tx('View design →')) + '</em></span></a></article>';
    }).join('') || '<p>' + (locale === 'tr' ? 'Şu anda eşleşen stoklu tasarım bulunamadı; koleksiyonları keşfedebilirsin.' : tx('No matching design is in stock right now; explore the collections.')) + '</p>';
  }
  globalThis.AsteriaChakraProducts = Object.freeze({render});
})();
} else {
(() => {
  'use strict';
  const root = () => { const r = globalThis.Shopify?.routes?.root || '/'; return r.endsWith('/') ? r : r + '/'; };
  const esc = v => String(v == null ? '' : v).replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;').replaceAll("'","&#039;");
  const fold = v => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ı/g,'i').toLowerCase();
  const money = (cents, locale, currency) => {
    try { return new Intl.NumberFormat(locale === 'tr' ? 'tr-TR' : 'en-US', {style:'currency',currency:currency || 'TRY'}).format(Number(cents) / 100); }
    catch (_) { return (Number(cents) / 100).toFixed(2) + ' ' + (currency || ''); }
  };
  async function load(row) {
    try {
      const response = await fetch(root() + 'products/' + encodeURIComponent(row.handle) + '.js', {credentials:'same-origin',headers:{Accept:'application/json'}});
      if (!response.ok) return null;
      const product = await response.json();
      if (String(product.id) !== String(row.productId) || !product.featured_image) return null;
      const variant = (product.variants || []).find(v => String(v.id) === String(row.variantId) && String(v.sku) === String(row.sku) && v.available === true && Number(v.price) > 0);
      return variant ? {row, product, variant} : null;
    } catch (_) { return null; }
  }
  function candidates(stones) {
    const groups = globalThis.AsteriaBirthChartData?.productsByIntent || {};
    const selected = stones.map(fold);
    const seen = new Set();
    const rows = [];
    for (const group of Object.values(groups)) for (const row of group) {
      if (seen.has(row.productId)) continue;
      seen.add(row.productId);
      const matched = selected.reduce((score, stone) => score + (fold(row.matches).includes(stone) ? 1 : 0), 0);
      if (matched) rows.push({row, matched});
    }
    return rows.sort((a,b) => b.matched - a.matched || b.row.score - a.row.score).map(x => x.row).slice(0,12);
  }
function matchedFamilies(product,stones,locale){
 const title=String(product.title||'').toLocaleLowerCase('tr-TR');
 const tags=new Set((Array.isArray(product.tags)?product.tags:[]).map(t=>String(t).toLocaleLowerCase('tr-TR')));
 const families=new Map();
 const aliases={'jade-yesim-ceyt-tasi':['jade','yeşim','ceyt'],'lapis-lazuli-tasi':['lapis'],'necef-tasi':['necef','kristal'],'kuvars-tasi':['kuvars','kristal']};
 for(const stone of stones||[]){
  const r=globalThis.AsteriaZodiacData?.routes?.[stone],media=r?globalThis.AsteriaStoneMedia?.[r.profile]:null;
  if(!media)continue;
  const names=aliases[r.profile]||[media.titleTr];
  const tag='tas_'+r.profile.replace(/-tasi$/,'').replace('jade-yesim-ceyt','yesim');
  if(tags.has(tag)||names.some(n=>title.includes(n.toLocaleLowerCase('tr-TR'))))families.set(r.profile,locale==='tr'?media.titleTr:media.titleEn);
 }
 return [...families.values()];
}

  async function render(host, stones, locale, currency) {
    if (!host) return;
    const run = String(Date.now()) + Math.random();
    host.dataset.run = run;
    host.innerHTML = '<p>' + (locale === 'tr' ? 'Gerçek tasarımlar kontrol ediliyor…' : 'Checking real designs…') + '</p>';
    const rows = candidates(stones);
    const found = (await Promise.all(rows.map(load))).filter(Boolean).map(item=>({...item,families:matchedFamilies(item.product,stones,locale)})).filter(item=>item.families.length).slice(0,4);
    if (host.dataset.run !== run) return;
    host.innerHTML = found.map(({row,product,variant,families}) => {
      const href = root() + 'products/' + row.handle + '?variant=' + row.variantId;
      return '<article class="ae-gate-product"><a href="' + esc(href) + '"><img src="' + esc(product.featured_image.replace(/^(?:http:)?\/\//,'https://')) + '" alt="' + esc(product.title) + '" loading="lazy" decoding="async"><span><strong>' + esc(product.title) + '</strong><small class="ae-chakra__product-reason">' + esc(locale==='tr'?'Profilindeki '+families.join(', ')+' taşları bu tasarımda sana eşlik ediyor.':'The '+families.join(', ')+' stones in your profile are featured in this design.') + '</small><small>' + esc(money(variant.price,locale,currency)) + '</small><em>' + esc(locale === 'tr' ? 'Ürünü gör →' : 'View design →') + '</em></span></a></article>';
    }).join('') || '<p>' + (locale === 'tr' ? 'Şu anda eşleşen stoklu tasarım bulunamadı; koleksiyonları keşfedebilirsin.' : 'No matching design is in stock right now; explore the collections.') + '</p>';
  }
  globalThis.AsteriaChakraProducts = Object.freeze({render});
})();
}
